import { useMemo } from 'react'
import { usePolicies } from '@/shared/hooks/queries/use-policies'

/**
 * Policy numbers (`policyExternalId`) of all the user's pet policies, the ids
 * the Claims API reads claims by. Inactive policies are kept on purpose: their
 * past claims still belong in the user's history
 */
export function usePetPolicyIds() {
  const { data: policies = [], isLoading } = usePolicies()
  const policyIds = useMemo(
    () => [
      ...new Set(
        policies
          .map((policy) => policy.policyExternalId)
          .filter((id) => !!id)
          .map(String),
      ),
    ],
    [policies],
  )
  return { policyIds, isLoading }
}
